<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Slides
                </div>
                <app-draggable :list="element.object.values.slides" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.slides.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.slides"
                        class="draggable mb-4"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`Slide ${(index + 1)} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <div>
                            <label class="text-xs">
                                Image
                            </label>
                            <app-field-file
                                class="mt-2"
                                v-model="element.object.values.slides[index].image"
                                :types="{images: true, files: false}"
                            />
                        </div>

                        <app-field-text
                            label="Label"
                            v-model="element.object.values.slides[index].label"
                        />

                        <div class="flex flex-wrap items-center py-6">
                            <div class="w-1/2">
                                <label class="text-xs font-bold text-black">
                                    Disable gradient?
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-toggle-field
                                    :required="false"
                                    class="reset"
                                    :classes="{ input: { 'input--composer': true } }"
                                    v-model="element.object.values.slides[index].disable_gradient"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap items-center py-6">
                            <div class="w-1/2">
                                <label class="text-xs font-bold text-black">
                                    Title font Pacifico?
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-toggle-field
                                    :required="false"
                                    class="reset"
                                    :classes="{ input: { 'input--composer': true } }"
                                    v-model="element.object.values.slides[index].pacifico_enabled"
                                />
                            </div>
                        </div>

                        <app-field-text
                            label="Title"
                            v-model="element.object.values.slides[index].title"
                        />

                        <app-field-text
                            label="Subtitle"
                            v-model="element.object.values.slides[index].subtitle"
                        />

                        <app-field-text
                            label="URL"
                            v-model="element.object.values.slides[index].url"
                        />

                        <app-field-text
                            label="Button Text"
                            v-model="element.object.values.slides[index].button_text"
                        />

                        <app-field-text
                            label="Pricing Text"
                            v-model="element.object.values.slides[index].pricing_text"
                        />

                        <app-field-text
                            label="Pricing Total"
                            v-model="element.object.values.slides[index].pricing_total"
                        />

                        <div class="bg-white p-4 pl-0 font-bold text-sm" style="border-top: 1px solid #d3d3d3;">
                            Promo bar
                        </div>

                        <div class="pt-2 pb-4 text-sm">You can complete either or both of the below fields</div>

                        <app-field-text
                            label="Promo title (will be orange)"
                            v-model="element.object.values.slides[index].promo_ttl"
                        />

                        <app-field-text
                            label="Promo sub title"
                            v-model="element.object.values.slides[index].promo_subttl"
                        />


                        <div class="bg-white p-4 pl-0 font-bold text-sm" style="border-top: 1px solid #d3d3d3;">
                            Location controls
                        </div>

                        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);" v-if="typeof element.object.values.slides[index].locations !== 'undefined' && element.object.values.slides[index].locations.options.length > 0">
                            <div class="w-1/2">
                                <label class="text-xs text-grey-darker">
                                    Always display banner
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-toggle-field
                                    :required="false"
                                    class="reset"
                                    :classes="{ input: { 'input--composer': true } }"
                                    v-model="element.object.values.slides[index].locations.options[0].checked"
                                />
                            </div>
                        </div>

                        <div v-if="typeof element.object.values.slides[index].locations !== 'undefined' && element.object.values.slides[index].locations.options.length > 0 && !element.object.values.slides[index].locations.options[0].checked">
                            <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                                <div class="w-1/2">
                                    <label class="text-xs text-grey-darker">
                                        Display if no user location set
                                    </label>
                                </div>
                                <div class="w-1/2 text-right">
                                    <app-toggle-field
                                        :required="false"
                                        class="reset"
                                        :classes="{ input: { 'input--composer': true } }"
                                        v-model="element.object.values.slides[index].locations.no_location_display"
                                    />
                                </div>
                            </div>

                        </div>

                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no slides.
                </p>

                <div class="px-4 text-right w-full mb-8">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    CTA 1
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-full">
                        <label class="text-xs text-grey-darker">
                            Image
                        </label>
                        <app-field-file
                            class="reset mt-2"
                            v-model="element.object.values.cta_1_image"
                            :types="{images: true, files: false}"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            URL
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_url"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_title"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Description
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_description"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Button Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_button_text"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Pricing Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_pricing_text"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Pricing Total
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_1_pricing_total"
                        />
                    </div>
                </div>
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    CTA 2
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-full">
                        <label class="text-xs text-grey-darker">
                            Image
                        </label>
                        <app-field-file
                            class="reset mt-2"
                            v-model="element.object.values.cta_2_image"
                            :types="{images: true, files: false}"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            URL
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_url"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_title"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Description
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_description"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Button Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_button_text"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Pricing Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_pricing_text"
                        />
                    </div>
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Pricing Total
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.cta_2_pricing_total"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import Api from '@/api/index.js';

    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';

    import ColourField from '@/components/fields/inputs/Colour';
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import FileField from '@/components/fields/inputs/File';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import draggable from 'vuedraggable';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-colour-field': ColourField,
            'app-toggle-field': ToggleField,
            'app-field-file': FileField,
        },
        props: {
            element: {
                type: Object,
                required: true
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        data: () => ({
            fields: {
                text: {
                    name: 'Text',
                    attribute: 'text'
                },
                size: {
                    name: 'Size',
                    attribute: 'size',
                    options: [
                        {
                            value: 'default',
                            label: 'Default'
                        },
                        {
                            value: 'sml',
                            label: 'Small'
                        },
                        {
                            value: 'md',
                            label: 'Medium'
                        },
                        {
                            value: 'lg',
                            label: 'Large'
                        },
                        {
                            value: 'xl',
                            label: 'Extra Large'
                        },
                    ]
                },
                locations: {
                    name: 'Location',
                    attribute: 'location',
                    no_location_display: false,
                    options: [
                        {
                            id: 0,
                            name: 'All',
                            slug: 'all',
                            checked: true
                        },
                    ]
                },
            }
        }),

        created() {
            // Get all locations
            return Api.request('get', `locations/locations?filterForWebsite=true`)
                .then(({ data }) => {
                    // Push all locations to 'fields.locations', so we can use this to check and create each slides locations for initial instance
                    data.locations.forEach((location, index) => {
                        location['checked'] = false;
                        this.fields.locations.options.push(location);
                    });

                    // Loop through all locations
                    this.fields.locations.options.forEach((loc, locIndex) => {

                        /**
                         * CAROUSEL SLIDES
                         */
                        // Loop through each slide and check if locations is defined - this is to prevent errors as they won't exist initially
                        this.element.object.values.slides.forEach((slide, index) => {
                            if (typeof this.element.object.values.slides[index].locations == 'undefined') {
                                this.$set(this.element.object.values.slides[index], 'locations', JSON.parse(JSON.stringify(this.fields.locations)));
                            }

                            // Check if any new locations have been created and add them in
                            if (typeof this.element.object.values.slides[index].locations.options.find(o => o.name === this.fields.locations.options[locIndex].name) === 'undefined') {
                                // this.element.object.values.slides[index].locations.options.push(loc);

                                this.$set(this.element.object.values.slides[index].locations.options, this.element.object.values.slides[index].locations.options.length, JSON.parse(JSON.stringify(loc)));
                            }
                        });

                        /**
                         * CTA SLIDES
                         */
                        // Loop through each slide and check if locations is defined - this is to prevent errors as they won't exist initially
                        this.element.object.values.cta_special_box.ctas.forEach((cta, index) => {
                            if (typeof this.element.object.values.cta_special_box.ctas[index].locations == 'undefined') {
                                this.$set(this.element.object.values.cta_special_box.ctas[index], 'locations', JSON.parse(JSON.stringify(this.fields.locations)));
                            }

                            // Check if any new locations have been created and add them in
                            if (typeof this.element.object.values.cta_special_box.ctas[index].locations.options.find(o => o.name === this.fields.locations.options[locIndex].name) === 'undefined') {
                                // this.element.object.values.cta_special_box.ctas[index].locations.options.push(loc);

                                this.$set(this.element.object.values.cta_special_box.ctas[index].locations.options, this.element.object.values.cta_special_box.ctas[index].locations.options.length, JSON.parse(JSON.stringify(loc)));
                            }
                        });
                    });
                });
        },

        methods: {
            add() {
                this.element.object.values.slides.push({
                    'image': null,
                    'title': '',
                    'url': ''
                });

                // Add in location options to new slide
                this.$set(this.element.object.values.slides[this.element.object.values.slides.length - 1], 'locations', JSON.parse(JSON.stringify(this.fields.locations)));
            },

            remove(index) {
                this.element.object.values.slides.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/HomepageHeaderBlocksSettings.vue